module.exports = __webpack_public_path__ + "media/data_tables/sort_both-94b34ff5.png";